import React, {FunctionComponent, useEffect, useState} from "react";

import {DatasetMultiSelect} from "components/basic/dropdowns/dataset/DatasetMultiSelect";
import TimeUnitDropdown from "components/basic/dropdowns/time-unit-dropdown/TimeUnitDropdown";
import DatasetConfigEditor from "./dataset-config-editor/DatasetConfigEditor";

import {Button} from "primereact/button";
import {Dialog} from "primereact/dialog";
import {InputNumber} from "primereact/inputnumber";

import {ITableConfigProp} from "../common/api/interfaces/interfaces";

const defaultDataInputOutputTableConfig: ITableConfigProp = {
    config: {
        alignStartTo: "HOURS",
        timeOffset: 0,
        timeOffsetUnits: "HOURS",
        dataFrequency: "HOURS",
        updateFrequency: 5,
    },
    datasets: []
};

function DataInputOutputTableEditor({config, onConfigChange}) {
    let conf: ITableConfigProp = config ?? defaultDataInputOutputTableConfig;

    if (Object.keys(conf).length === 0) {
        conf = defaultDataInputOutputTableConfig;
    }

    const [currentConfig, setCurrentConfig] = useState<ITableConfigProp>(conf);
    const [selectedDatasets, setSelectedDatasets] = useState<string[]>();
    const [datasetConfigEditorIsVisible, setDatasetConfigEditorVisibility] = useState(false);

    if (conf.datasets && conf.datasets.length > 0 && !selectedDatasets) {
        const datasets = conf.datasets.map((dataset: any) => {
            return dataset.identifier;
        });
        setSelectedDatasets(datasets);
    }

    useEffect(() => {
        onConfigChange(currentConfig);
    }, [currentConfig]);


    const handleDatasetChange = (e: any) => {
        setSelectedDatasets(e);

        const selectedDatasetsArray = e.map((identifier: string) => {
            const oldDataset = currentConfig.datasets.find((oldDataset) => {
                    return oldDataset.identifier === identifier;
                }
            );
            if (oldDataset) {
                return oldDataset;
            } else {
                return {
                    identifier,
                };
            }
        });

        setCurrentConfig({
            ...currentConfig,
            datasets: selectedDatasetsArray,
        });
    };

    const handleDatasetConfigEditClick = () => {
        setDatasetConfigEditorVisibility(true);
    };

    const handleConfigChange = (e: any) => {

        setCurrentConfig({
            ...currentConfig,
            config: {
                ...currentConfig.config,
                [e.target.id]: e.target.value.toString().toUpperCase(),
            },
        });
    };


    return (
        <div>
            <div className="grid p-fluid">
                <div className="col-12 flex gap-2 flex-column mb-3">
                    <label htmlFor="datasets">Datasets</label>
                    <div className="flex">
                        <DatasetMultiSelect id="datasets" value={selectedDatasets} onChange={handleDatasetChange}/>
                        <Button
                            icon="pi pi-pencil"
                            type="button"
                            className="p-button-secondary"
                            style={{marginLeft: "10px"}}
                            tooltip="Edit dataset config"
                            onClick={() => handleDatasetConfigEditClick()}
                        />
                        <Dialog
                            onHide={() => setDatasetConfigEditorVisibility(false)}
                            visible={datasetConfigEditorIsVisible}
                            header="Edit dataset config"
                            style={{width: "min(100vw, 1200px)", height: "500x"}}
                        >
                            <DatasetConfigEditor
                                currentConfig={currentConfig}
                                setCurrentConfig={setCurrentConfig}
                                onConfigChange={onConfigChange}
                            />
                        </Dialog>
                    </div>
                </div>
                <div className="col-4 gap-2 flex flex-column justify-content-center align-items-center">
                    <label htmlFor="timeOffset">Time Offset</label>
                    <div className="p-inputgroup">
                        <InputNumber
                            id="timeOffset"
                            value={currentConfig.config?.timeOffset as number}
                            onValueChange={handleConfigChange}
                        />
                        <TimeUnitDropdown id="timeOffsetUnits" className="p-inputgroup-addon p-0"
                                          value={ currentConfig.config?.timeOffsetUnits ? currentConfig.config.timeOffsetUnits : ""} onChange={handleConfigChange}/>
                    </div>
                </div>
                <div className="col-2 gap-2 flex flex-column justify-content-center align-items-center">
                    <label htmlFor="dataFrequency">Data Frequency</label>
                    <TimeUnitDropdown id="dataFrequency" className="p-0"
                                      value={currentConfig.config?.dataFrequency ? currentConfig.config.dataFrequency : "" } onChange={handleConfigChange}/>
                </div>
                <div className="col-2 gap-2 flex flex-column justify-content-center align-items-center">
                    <label htmlFor="alignStartTo">Align Start To</label>
                    <TimeUnitDropdown id="alignStartTo" className="p-0"
                                      value={currentConfig.config?.alignStartTo ? currentConfig.config.alignStartTo : ""} onChange={handleConfigChange}/>
                </div>
                <div className="col-2 gap-2 flex flex-column justify-content-center align-items-center">
                    <label htmlFor="updateFrequency">Update Frequency</label>
                    <div className="p-inputgroup w-full">
                        <InputNumber
                            id="updateFrequency"
                            value={currentConfig.config?.updateFrequency as number}
                            onValueChange={handleConfigChange}
                        />
                        <span className="p-inputgroup-addon">s</span>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default DataInputOutputTableEditor as FunctionComponent;